//@ts-nocheck
import React from 'react';
const defaultValue = {};
export const MappingContext = /*#__PURE__*/React.createContext(defaultValue);